/**
 * Created by H
 * User: huangcan
 * Date: 2019-06-20
 * Time: 16:00
 * tips: 分页操作
 */

export default {
  methods: {
    /**
     * 请求下一页
     * @param type
     * @param size
     */
    nextPage(type, size) {
      let currentPage
      let pageTotal
      if (type) {
        currentPage = this[type].pagination.currentPage || 1
        pageTotal = this[type].pagination.pageTotal
      } else {
        currentPage = this.pagination.currentPage || 1
        pageTotal = this.pagination.pageTotal
      }
      if (currentPage + 1 <= pageTotal) {
        this._pagination(currentPage + 1, type, size)
      } else {
        this.$notify({
          type: 'info',
          message: '已经是最后一页了~！😂'
        })
      }
    },
    /**
     * 请求上一页
     * @param type
     * @param size
     */
    prevPage(type, size) {
      let currentPage
      let pageTotal
      if (type) {
        currentPage = this[type].pagination.currentPage || 1
        pageTotal = this[type].pagination.pageTotal
      } else {
        currentPage = this.pagination.currentPage || 1
        pageTotal = this.pagination.pageTotal
      }
      if (currentPage - 1 <= pageTotal && currentPage !== 1) {
        this._pagination(currentPage - 1, type, size)
      } else {
        this.$notify({
          type: 'info',
          message: '已经是第一页了~！😂'
        })
      }
    },
    /**
     * 跳转页面
     * @param val
     * @param type
     * @param size
     */
    jumpPage(val, type, size) {
      let pageTotal
      if (type) {
        pageTotal = this[type].pagination.pageTotal
      } else {
        pageTotal = this.pagination.pageTotal
      }
      if (val <= pageTotal) {
        this._pagination(val, type, size)
      } else {
        this.$notify({
          type: 'info',
          message: '无法跳转~！😂'
        })
      }
    },
    /**
     * 分页操作
     * @param value
     * @param type
     * @param size
     * @private
     */
    _pagination(value, type, size) {
      const operate = (vm, newValue, type) => {
        // type === pagination 是单独只使用分页功能
        if (type === 'tableData' || type === 'pagination') {
          vm.pagination.currentPage = newValue
        } else {
          vm[type].pagination.currentPage = newValue
        }
        this._parentComponentRequest(vm, newValue, type, size || '')
      }
      if (this.type === 'pagination') {
        operate(this, value, type || this.type)
      } else {
        this._notifyEmit(value, (vm, newValue, type) => {
          operate(vm, newValue, type)
        })
      }
    },
    /**
     * 父子组件更新数据
     * @param cb
     * @param newValue
     * @private
     */
    _notifyEmit(newValue, cb) {
      this.$emit('updateData', cb, newValue, this.type || 'tableData')
    },
    /**
     * 改变页面展示数据条数
     * @param val
     * @param type
     * @private
     */
    changePageSize(val, type) {
      this._pagination(1, type, val)
    }
  }
}
